import React from "react";
import IContainerOptions from "../../../../../model/interface/form/elementOptions/IContainerOptions";
import Utils from "../../../../../utils";
import IWidgetProps from "../../../../../model/interface/widget/IWidgetProps";
import IFormElementFunctions from "../../../../../model/interface/form/IFormElementFunctions";
import {Card} from "antd";
import ConditionEditor from "./optionEditor/ConditionEditor";
import BaseContainerWidget from "../../widget/ContainerWidget";
import Collapse from "../../../../shared/display/collapse/Collapse";
import IRestResource from "../../../../../model/interface/api/IRestResource";
import ContentTypesService from "../../../../../model/service/dataStorage/ContentTypesService";
import DataStorageHelper from "../../../../../utils/DataStorageHelper";
import {getBaseFieldsList} from "../../../../../model/interface/api/IRestServiceFilters";
import {debounce} from "underscore";

interface IProps extends IWidgetProps<IFormElementFunctions, IContainerOptions> {

}

interface IState {
    conditionMet?: boolean
    remoteConditionMet?: boolean
}

class ContainerWidget extends React.Component<IProps, IState> {
    constructor(props: IWidgetProps<IFormElementFunctions, IContainerOptions>) {
        super(props);
        this.state = {
            conditionMet: undefined,
            remoteConditionMet: undefined
        }
        this.checkConditionalRequired = debounce(this.checkConditionalRequired, 800);
    }

    componentDidMount() {
        const {resource} = this.props
        this.onChange()
    }

    componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>) {
        const {functions, id} = this.props
        this.onChange(prevProps);
        if (functions.onChildHidden && (this.state.conditionMet &&  this.state.remoteConditionMet)  !== (prevState.conditionMet && prevState.remoteConditionMet)) {
            functions.onChildHidden(id, !!this.state.conditionMet && !!this.state.remoteConditionMet)
        }
    }

     onChange(prevProps?: Readonly<IProps>) {
        const {functions, options, resource} = this.props

        if (Utils.toBoolean(options.collapsable) && (!prevProps || (JSON.stringify(resource) !== JSON.stringify(prevProps.resource)))) {
            const met = (!options.conditions || options.conditions.length) ? ConditionEditor.evaluateConditions(options.conditions, functions.getCurrentValue) : undefined
            if ((met === undefined || met || !prevProps) && options.remoteConditions) {
                this.checkConditionalRequired(resource, prevProps?.resource)?.then(r => this.setState({conditionMet: met}))
            } else {
                this.setState({conditionMet: met})
            }

        }
    }

    checkConditionalRequired = (original?: IRestResource, change?: IRestResource) => {
        const {functions, resource, options} = this.props
        if (original && options.remoteConditions && Object.keys(options.remoteConditions).length > 0) {
            const run = change ? getBaseFieldsList(options.remoteConditions).some(field => original[field] !== change[field]) : true
            if (run) {
                return ContentTypesService.evaluateRecordConditions({
                    filters: options.remoteConditions, resource: resource ? {
                        object: DataStorageHelper.buildFormData(resource, functions.getContentType()),
                        className: functions.getContentType().fullClassName
                    } : undefined
                }).then((r) => {
                    this.setState({remoteConditionMet: r})
                })
            }
        }
        return Promise.resolve()
    }


    render() {
        const {options} = this.props
        const {bordered} = options
        const {conditionMet, remoteConditionMet} = this.state

        const content = <>
            <BaseContainerWidget {...this.props}/>
        </>

        const collapsed = conditionMet === undefined && remoteConditionMet === undefined ? false : (conditionMet === undefined || conditionMet) && (remoteConditionMet === undefined || remoteConditionMet)

        return (
            <Collapse collapsed={collapsed}>
                {bordered ? (
                    <Card>
                        {content}
                    </Card>
                ) : (
                    content
                )}
            </Collapse>
        );
    }
}

export default ContainerWidget